import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationLink from '@cotyorg/ccx-molecules/NavigationLink';

const MobileNavigationHorizontalListItem = ({
  page,
  nested,
  navigation,
  showPage,
  goBack,
  goBackDone,
  PageComponent,
  rightChevronIconSrc,
  leftChevronIconSrc,
  disableSwipe,
}) => {
  const className = classNames('mobile-navigation__list-item', {
    'mobile-navigation__list-item--nested': nested,
  });

  const navigationLinkClassName = classNames(
    'mobile-navigation__link',
    {
      'mobile-navigation__link--nested': nested,
    },
  );

  const {
    name, pages, url, slug, openInNewWindow,
  } = page;

  return (
    <li role="menuitem" className={className} data-test="mobile-navigation-horizontal-list-item">
      <NavigationLink
        isMobileNav
        name={name}
        pages={pages}
        url={url}
        openInNewWindow={openInNewWindow}
        nested={nested}
        extraClass={navigationLinkClassName}
        iconExtraClass="mobile-navigation__link-icon"
        textExtraClass="mobile-navigation__link-text"
        rightChevronIconSrc={rightChevronIconSrc}
        leftChevronIconSrc={leftChevronIconSrc}
        onClick={(e) => {
          if (pages && pages.length) {
            e.preventDefault();
            showPage(slug);
          }
        }}
      />
      {page.pages && (
        <PageComponent
          page={page}
          nested
          navigation={navigation}
          showPage={showPage}
          goBack={goBack}
          goBackDone={goBackDone}
          leftChevronIconSrc={leftChevronIconSrc}
          rightChevronIconSrc={rightChevronIconSrc}
          disableSwipe={disableSwipe}
        />
      )}
    </li>
  );
};

MobileNavigationHorizontalListItem.propTypes = {
  page: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    pages: PropTypes.array,
    openInNewWindow: PropTypes.bool,
  }),
  navigation: PropTypes.shape({
    pages: PropTypes.array.isRequired,
    displayedPages: PropTypes.array.isRequired,
  }),
  nested: PropTypes.bool.isRequired,
  showPage: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goBackDone: PropTypes.func.isRequired,
  PageComponent: PropTypes.func.isRequired,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  disableSwipe: PropTypes.bool,
};

export default MobileNavigationHorizontalListItem;
